<template>
  <div class="flex flex-col bg-white rounded-sm text-gray mx-2 my-3 p-2">
    <div class="px-4 mb-2">
      <span class="title">Monitoring</span>
    </div>

    <div class="border-b border-gray-200 mb-4">
      <nav class="flex flex-wrap gap-x-6 gap-y-0 px-4" aria-label="Tabs">
        <div
          :class="[
            currentRoute === 'health'
              ? 'border-primary text-primary'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
            'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer',
          ]"
          @click="select('health')"
        >
          Service Health
        </div>
        <div
          :class="[
            currentRoute === 'audits'
              ? 'border-primary text-primary'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
            'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer',
          ]"
          @click="select('audits')"
        >
          Audit Logs
        </div>
      </nav>
    </div>

    <div class="px-2 pb-2">
      <IntegrationHealth v-if="currentRoute === 'health'" ref="healthRef" />
      <IntegrationAudits v-if="currentRoute === 'audits'" ref="auditsRef" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref } from "vue";
import IntegrationHealth from "./tabs/IntegrationHealth.vue";
import IntegrationAudits from "./tabs/IntegrationAudits.vue";

type TabChild = { refresh?: () => void } | null;
type MonitoringRoute = "health" | "audits";

const currentRoute = ref<MonitoringRoute>("health");
const healthRef = ref<TabChild>(null);
const auditsRef = ref<TabChild>(null);

const refreshActiveTab = () => {
  if (currentRoute.value === "health") healthRef.value?.refresh?.();
  else if (currentRoute.value === "audits") auditsRef.value?.refresh?.();
};

const select = (route: MonitoringRoute) => {
  currentRoute.value = route;
  nextTick(() => refreshActiveTab());
};
</script>
